export default function SteamEffect() {
  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden">
      <svg
        className="absolute left-1/2 -translate-x-1/2 bottom-0 w-64 h-40 md:w-96 md:h-56"
        viewBox="0 0 400 250"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <defs>
          <linearGradient id="steamGrad1" x1="0" y1="1" x2="0" y2="0">
            <stop offset="0%" stopColor="#ffffff" stopOpacity="0" />
            <stop offset="50%" stopColor="#ffffff" stopOpacity="0.3" />
            <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
          </linearGradient>
        </defs>

        <path
          d="M100,250 Q130,200 100,150 T110,50"
          fill="none"
          stroke="url(#steamGrad1)"
          strokeWidth="16"
          strokeLinecap="round"
          opacity="0.6"
        >
          <animate
            attributeName="d"
            values="M100,250 Q130,200 100,150 T110,50;M100,250 Q70,200 110,150 T90,50;M100,250 Q130,200 100,150 T110,50"
            dur="4s"
            repeatCount="indefinite"
          />
          <animate
            attributeName="opacity"
            values="0.6;0.2;0.6"
            dur="4s"
            repeatCount="indefinite"
          />
        </path>

        <path
          d="M200,250 Q230,200 190,150 T210,50"
          fill="none"
          stroke="url(#steamGrad1)"
          strokeWidth="18"
          strokeLinecap="round"
          opacity="0.5"
        >
          <animate
            attributeName="d"
            values="M200,250 Q230,200 190,150 T210,50;M200,250 Q170,200 210,150 T190,50;M200,250 Q230,200 190,150 T210,50"
            dur="5s"
            repeatCount="indefinite"
          />
          <animate
            attributeName="opacity"
            values="0.5;0.15;0.5"
            dur="5s"
            repeatCount="indefinite"
          />
        </path>

        <path
          d="M300,250 Q270,200 310,150 T290,50"
          fill="none"
          stroke="url(#steamGrad1)"
          strokeWidth="14"
          strokeLinecap="round"
          opacity="0.55"
        >
          <animate
            attributeName="d"
            values="M300,250 Q270,200 310,150 T290,50;M300,250 Q330,200 290,150 T310,50;M300,250 Q270,200 310,150 T290,50"
            dur="4.5s"
            repeatCount="indefinite"
          />
          <animate
            attributeName="opacity"
            values="0.55;0.2;0.55"
            dur="4.5s"
            repeatCount="indefinite"
          />
        </path>
      </svg>
    </div>
  );
}
